import React from 'react';
import ReactDOM from 'react-dom';
import Autocomplete from 'react-autocomplete';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './FlightAutocomplete.css';

const propTypes = {
  callBack: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.object,
  searchAirport: PropTypes.func.isRequired
};

const defaultProps = {
  value: null
};

class FlightAutocomplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      airports: [],
      loading: false
    };

    this.handleResponse = this.handleResponse.bind(this);
  }

  componentDidMount() {
    const _this = this;

    ReactDOM.findDOMNode(this.refs[this.props.id].refs.input).addEventListener('change', event => {
      const value = event.target.value;
      if (!value || value.length === 0) {
        _this.setState({ value: '', airports: [] });
        _this.props.callBack(null);
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value && nextProps.value.name) {
      const airportName =
        nextProps.value.name.indexOf(nextProps.value.code) !== -1
          ? nextProps.value.name
          : `${nextProps.value.name} (${nextProps.value.code})`;
      const airportSelected = {
        index: 0,
        name: airportName,
        code: nextProps.value.code,
        searchCode: nextProps.value.searchCode
      };
      this.setState({
        value: airportSelected.name,
        airports: [airportSelected]
      });
    }
  }

  handleResponse(value, response) {
    var index = 1;
    for (var i = 0; i < response.length; i++) {
      response[i].index = index++;
      response[i].name = `${response[i].name} (${response[i].code})`;
    }
    this.setState({ airports: response, loading: false });
  }

  getAirports(value) {
    if (value && value.length >= 3) {
      this.props.searchAirport(value).then(response => this.handleResponse(value, response));
    } else {
      this.setState({ airports: [], loading: false });
      return false;
    }
  }

  displayMenu(items, value) {
    var menu = <div />;
    if (value) {
      menu = (
        <Row className="menu">
          <Col xs={12}>
            <Row className="menu-group">
              <Col xs={12}>
                <ul>{items.length > 0 && items}</ul>
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }
    return menu;
  }

  render() {
    return (
      <div
        id={`componentFlightAutocomplete-${this.props.id}`}
        className="componentFlightAutocomplete">
        <span
          className="arrow-down"
          onMouseOver={() =>
            ReactDOM.findDOMNode(this.refs[this.props.id].refs.input).classList.add('selected')
          }
          onMouseOut={() =>
            ReactDOM.findDOMNode(this.refs[this.props.id].refs.input).classList.remove('selected')
          }
        />
        <Row>
          <Col>
            <ControlLabel className="label"> {this.props.title} </ControlLabel>
          </Col>
        </Row>
        <Row>
          <Autocomplete
            wrapperStyle={{}}
            inputProps={{
              id: `${this.props.id}`,
              placeholder: this.props.placeholder,
              className: 'form-control input data-hj-whitelist',
              onFocus: () => {
                this.setState({ airports: [], loading: false });
              }
            }}
            value={this.state.value}
            ref={this.props.id}
            items={this.state.airports}
            getItemValue={item => item.name}
            onSelect={(value, item) => {
              this.setState({ value, airports: [item] });
              this.props.callBack(item);
            }}
            onChange={(event, value) => {
              this.setState({ value });
              this.getAirports(value);
            }}
            renderItem={(item, isHighlighted) => (
              <li
                key={item.index}
                id={`autocomplete-item-${this.props.id}-${item.index}`}
                className={['airport', isHighlighted ? 'highlight' : ''].join(' ')}>
                <a id={`autocomplete-link-item-${this.props.id}-${item.index}`}> {item.name}</a>
              </li>
            )}
            renderMenu={this.displayMenu}
          />
        </Row>
      </div>
    );
  }
}

FlightAutocomplete.propTypes = propTypes;
FlightAutocomplete.defaultProps = defaultProps;

export default FlightAutocomplete;



// WEBPACK FOOTER //
// ./src/components/searchBox/flightAutocomplete/FlightAutocomplete.jsx